import { useContext } from 'react';
import {
	BlanketContextType,
	BlanketContext
} from '../contexts/blanket.context';

export const useBlanket = (): BlanketContextType => useContext(BlanketContext);
